import { useIsLoading } from 'careand-redux/slices/ui/hooks';
import { api } from 'careand-redux/api/ApiThunks';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import IconButton from '@material-ui/core/IconButton';
import Icon from 'components/Utils/NewIcon';
import React, { useState } from 'react';
import ConfirmationDialog from 'components/Utils/ConfirmationDialog';
import MenuItem from '@material-ui/core/MenuItem';
import { ListItemIcon } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';

const TranslateDocumentButton = ({ document, onClose }) => {
  const isLoading = useIsLoading(api.Documents.translateDocument);
  const dispatch = useAppDispatch();

  const [confirm, setConfirm] = useState(false);

  async function onTranslate(event, language) {
    let language_code = LANGUAGES[language];
    setConfirm(false);
    await dispatch(
      api.Documents.translateDocument({
        id: document.id,
        language_code,
      }),
      {
        title: 'Translate Document',
        successText: 'Document translated successfully and saved',
      },
    );
    if (onClose) onClose();
  }

  return (
    !document.archived && (
      <>
        <MenuItem onClick={() => setConfirm(true)}>
          <ListItemIcon>
            <Icon src="language" height="20px" loading={isLoading} />
          </ListItemIcon>
          <ListItemText primary="Translate Document" />
        </MenuItem>
        {/*<IconButton className="ml-2">
          <Icon
            src="language"
            height="20px"
            width="20px"
            alt="Translate Document"
            showTooltip={true}
            loading={isLoading}
            onClick={() => setConfirm(true)}
          />
        </IconButton>*/}
        {confirm && (
          <ConfirmationDialog
            open={true}
            title="Translate Document"
            message="Please select the language you want to translate the document to."
            form={[
              {
                type: 'select',
                label: 'Select Language',
                inputs: Object.keys(LANGUAGES),
                value: 'English',
              },
            ]}
            confirmLabel="Translate"
            onCancel={() => setConfirm(false)}
            onConfirm={(ev, form) => onTranslate(ev, form['Select Language'])}
          />
        )}
      </>
    )
  );
};

export default TranslateDocumentButton;

const LANGUAGES = {
  Afrikaans: 'af',
  Albanian: 'sq',
  Amharic: 'am',
  Arabic: 'ar',
  Armenian: 'hy',
  Assamese: 'as',
  Aymara: 'ay',
  Azerbaijani: 'az',
  Bambara: 'bm',
  Basque: 'eu',
  Belarusian: 'be',
  Bengali: 'bn',
  Bhojpuri: 'bho',
  Bosnian: 'bs',
  Bulgarian: 'bg',
  Catalan: 'ca',
  Cebuano: 'ceb',
  'Chinese (Simplified)': 'zh-CN',
  'Chinese (Traditional)': 'zh-TW',
  Corsican: 'co',
  Croatian: 'hr',
  Czech: 'cs',
  Danish: 'da',
  Dhivehi: 'dv',
  Dogri: 'doi',
  Dutch: 'nl',
  English: 'en',
  Esperanto: 'eo',
  Estonian: 'et',
  Ewe: 'ee',
  'Filipino (Tagalog)': 'fil',
  Finnish: 'fi',
  French: 'fr',
  Frisian: 'fy',
  Galician: 'gl',
  Georgian: 'ka',
  German: 'de',
  Greek: 'el',
  Guarani: 'gn',
  Gujarati: 'gu',
  'Haitian Creole': 'ht',
  Hausa: 'ha',
  Hawaiian: 'haw',
  Hebrew: 'he',
  Hindi: 'hi',
  Hmong: 'hmn',
  Hungarian: 'hu',
  Icelandic: 'is',
  Igbo: 'ig',
  Ilocano: 'ilo',
  Indonesian: 'id',
  Irish: 'ga',
  Italian: 'it',
  Japanese: 'ja',
  Javanese: 'jv',
  Kannada: 'kn',
  Kazakh: 'kk',
  Khmer: 'km',
  Kinyarwanda: 'rw',
  Konkani: 'gom',
  Korean: 'ko',
  Krio: 'kri',
  Kurdish: 'ku',
  'Kurdish (Sorani)': 'ckb',
  Kyrgyz: 'ky',
  Lao: 'lo',
  Latin: 'la',
  Latvian: 'lv',
  Lingala: 'ln',
  Lithuanian: 'lt',
  Luganda: 'lg',
  Luxembourgish: 'lb',
  Macedonian: 'mk',
  Maithili: 'mai',
  Malagasy: 'mg',
  Malay: 'ms',
  Malayalam: 'ml',
  Maltese: 'mt',
  Maori: 'mi',
  Marathi: 'mr',
  'Meiteilon (Manipuri)': 'mni-Mtei',
  Mizo: 'lus',
  Mongolian: 'mn',
  'Myanmar (Burmese)': 'my',
  Nepali: 'ne',
  Norwegian: 'no',
  'Nyanja (Chichewa)': 'ny',
  'Odia (Oriya)': 'or',
  Oromo: 'om',
  Pashto: 'ps',
  Persian: 'fa',
  Polish: 'pl',
  'Portuguese (Portugal, Brazil)': 'pt',
  Punjabi: 'pa',
  Quechua: 'qu',
  Romanian: 'ro',
  Russian: 'ru',
  Samoan: 'sm',
  Sanskrit: 'sa',
  'Scots Gaelic': 'gd',
  Sepedi: 'nso',
  Serbian: 'sr',
  Sesotho: 'st',
  Shona: 'sn',
  Sindhi: 'sd',
  'Sinhala (Sinhalese)': 'si',
  Slovak: 'sk',
  Slovenian: 'sl',
  Somali: 'so',
  Spanish: 'es',
  Sundanese: 'su',
  Swahili: 'sw',
  Swedish: 'sv',
  'Tagalog (Filipino)': 'tl',
  Tajik: 'tg',
  Tamil: 'ta',
  Tatar: 'tt',
  Telugu: 'te',
  Thai: 'th',
  Tigrinya: 'ti',
  Tsonga: 'ts',
  Turkish: 'tr',
  Turkmen: 'tk',
  'Twi (Akan)': 'ak',
  Ukrainian: 'uk',
  Urdu: 'ur',
  Uyghur: 'ug',
  Uzbek: 'uz',
  Vietnamese: 'vi',
  Welsh: 'cy',
  Xhosa: 'xh',
  Yiddish: 'yi',
  Yoruba: 'yo',
  Zulu: 'zu',
};
